import React, { useState, useEffect } from 'react';
import styles from './offerConfiguration.module.scss';
import { Form, Button, Badge, Row, Container, Col } from 'react-bootstrap';
import { CustomButton } from '../../../../shared/customButton';
import { CustomDropdown } from '../../../../shared/customDropdown';
import { CustomTextField } from '../../../../shared/customTextField';
import { CustomTextArea } from '../../../../shared/customTextArea';
import makeAnimated from 'react-select/animated';
import ReactTooltip from 'react-tooltip';
import Datetime from 'react-datetime';
import Select from 'react-select';
import * as yup from 'yup';
import { Formik } from 'formik';
import { getAllCompanyUsers } from '../../../../../services/util/common';


const StageDetailsConfiguration = (props) => {

    const animatedComponents = makeAnimated();
    let [reviewersList, setReviewersList] = useState([]);

    //yup validations
    const schema = yup.object({
        jobTitle: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
        allocation: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^'),
        offerDescription: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').nullable(),
        offerReviewers: yup.array().required('Required').nullable(),
        packageReference: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').nullable(),
    });

    //on submit function
    const onSubmit = async (values) => {
        props.setSubmitValues(values)
        props.nextPage(2)
    }

    async function setReviwers() {
        let reviewesList = await getAllCompanyUsers();
        setReviewersList(reviewesList.data)
    }

    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            setReviwers();
        }
        return () => { unmounted = true };
    }, []);

    return (
        <div>

            <Formik
                enableReinitialize
                validationSchema={schema}
                onSubmit={(values) => onSubmit(values)}
                initialValues={{ jobTitle: props.values.jobTitle, allocation: props.values.allocation, offerReviewers: props.values.offerReviewers, offerDescription: props.values.offerDescription, packageReference: props.values.packageReference }}
            >

                {({
                    values,
                    errors,
                    setFieldValue,
                    handleChange,
                    handleSubmit,
                    submitCount
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>

                        <Row>
                            <Col >
                                <p className={styles.stepSubtopicName}>
                                    Basic Details
                                </p>
                            </Col>
                        </Row>
                        <div>
                            <CustomTextField
                                label="Job Title *"
                                name="jobTitle"
                                placeholder=""
                                classLabel="defaultLabel"
                                controlId="jobTitle"
                                type="text"
                                value={values.jobTitle}
                                classType="defaultTextBox"
                                handleOnChange={handleChange}
                                errorMessage={errors.jobTitle}
                                isInvalid={submitCount > 0 && !!errors.jobTitle}
                            />

                            <CustomTextField
                                label="Allocation"
                                name="allocation"
                                placeholder="project / department"
                                classLabel="defaultLabel"
                                controlId="allocation"
                                type="text"
                                value={values.allocation}
                                classType="defaultTextBox"
                                handleOnChange={handleChange}
                                errorMessage={errors.allocation}
                                isInvalid={submitCount > 0 && !!errors.allocation}
                            />

                            <CustomTextArea
                                label="Description"
                                name="offerDescription"
                                handleChange={handleChange}
                                values={values.offerDescription}
                                errorMessage={errors.offerDescription}
                                isInvalid={submitCount > 0 && !!errors.offerDescription}
                            />

                            <CustomTextField
                                label="Package Reference"
                                name="packageReference"
                                placeholder="ex:- 5"
                                classLabel="defaultLabel"
                                controlId="packageReference"
                                type="text"
                                value={values.packageReference}
                                classType="defaultTextBox"
                                handleOnChange={handleChange}
                                errorMessage={errors.packageReference}
                                isInvalid={submitCount > 0 && !!errors.packageReference}
                            />

                            <Form.Group controlId="exampleForm.ControlTextarea1">

                                <Form.Label className={styles.defaultLabel}>
                                    Reviewers &nbsp;
                                    <svg data-tip data-for={`reviewersList`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                    <ReactTooltip id={`reviewersList`} place="right" type="dark" effect="solid" clickable={true}>
                                        <div className={styles.toolTipBox}>{<p>Select the reviewers, in order to get approval to send the job offer.</p>}</div>
                                    </ReactTooltip>
                                </Form.Label>
                                <Select
                                    defaultValue={values.offerReviewers}
                                    options={reviewersList}
                                    isMulti={true}
                                    components={animatedComponents}
                                    name="offerReviewers"
                                    class="react-select__control"
                                    onChange={(e) => { setFieldValue('offerReviewers', e); }}
                                    getOptionValue={option => `${option._id}`}
                                    getOptionLabel={options => `${options.email} - ${options.first_name} ${options.last_name}`}
                                    styles={
                                        errors.offerReviewers === 'Required' ?
                                            {
                                                ...styles,
                                                control: (base, state) => ({
                                                    ...base,
                                                    '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                    border: '1px solid #dc3545', // default border color
                                                    borderRadius: '6px',
                                                    boxShadow: 'none', // no box-shadow
                                                }),
                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                    return {
                                                        ...styles,
                                                        background: isDisabled
                                                            ? null
                                                            : isSelected
                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                : isFocused
                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                    : null,
                                                        color: isDisabled
                                                            ? '#ccc'
                                                            : isSelected
                                                                ? '#24859A'
                                                                : '#24859A',
                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                        ':active': {
                                                            ...styles[':active'],
                                                            background:
                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                        },
                                                    };
                                                },
                                            }
                                            :
                                            {
                                                ...styles,
                                                control: (base, state) => ({
                                                    ...base,
                                                    '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                    border: '1px solid #bdbdbd', // default border color
                                                    borderRadius: '6px',
                                                    boxShadow: 'none', // no box-shadow
                                                }),
                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                    return {
                                                        ...styles,
                                                        background: isDisabled
                                                            ? null
                                                            : isSelected
                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                : isFocused
                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                    : null,
                                                        color: isDisabled
                                                            ? '#ccc'
                                                            : isSelected
                                                                ? '#24859A'
                                                                : '#24859A',
                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                        ':active': {
                                                            ...styles[':active'],
                                                            background:
                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                        },
                                                    };
                                                },
                                                multiValue: (styles) => {
                                                    return {
                                                        ...styles,
                                                        background: 'rgba(45, 166, 192, 0.1)',
                                                    };
                                                },
                                                multiValueLabel: (styles) => ({
                                                    ...styles,
                                                    color: '#24859A',
                                                }),
                                                multiValueRemove: (styles) => ({
                                                    ...styles,
                                                    color: '#24859A',
                                                    ':hover': {
                                                        backgroundColor: '#24859A',
                                                        color: 'white',
                                                    },
                                                }),
                                            }
                                    }
                                />
                                <p className={styles.errorMsg}>{errors.offerReviewers}</p>
                            </Form.Group>


                        </div>

                        <div className={styles.nexBtnDiv}>
                            <CustomButton
                                buttonType="submit"
                                label="Next"
                                type="primaryBtn"
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default StageDetailsConfiguration;
